import React from "react";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";

import {renderQuestion} from "../../../../../../../utils";
import {radioYesUID} from "../../../../../../../constants";
import InfoCard from "../../../DynamicStep/components/InfoCard";
import SafeHtml from "../../../../../../../../../components/SafeHtml";

const ExistingDepotStep = (props) => {
  const {
    questions: [existingDepotQ, depotNumberQ, cashAccountQ],
    onAnswerChange,
    dataService
  } = props;

  const hasExistingDepot = existingDepotQ.answer === radioYesUID;
  depotNumberQ.optional = !hasExistingDepot;

  const assetManagementConfig = React.useMemo(() => {
    return dataService.getBankConfig()['individual_asset_managment_config'];
  }, [dataService]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Container maxWidth={'sm'}>
          <Grid container spacing={2} justify={"center"}>
            {renderQuestion(existingDepotQ, onAnswerChange, dataService)}
            {hasExistingDepot && (
              <>
                {renderQuestion(depotNumberQ, onAnswerChange, dataService)}
                {renderQuestion(cashAccountQ, onAnswerChange, dataService)}
              </>
            )}
          </Grid>
        </Container>
      </Grid>
      {hasExistingDepot && (
        <Grid item xs={12}>
          <InfoCard isNewDesign info_text={<SafeHtml html={assetManagementConfig.info_for_existing_depot} />} />
        </Grid>
      )}
    </Grid>
  )
}

export default ExistingDepotStep;